exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sau-common-links {\n  width: 100%;\n  padding-top: 1rem;\n  padding-left: 1rem;\n  padding-bottom: 1rem;\n}\n@media screen and (min-width: 768px) {\n.sau-common-links {\n    height: 220px;\n    padding-top: 0;\n    padding-bottom: 0;\n    padding-left: 180px;\n    background-size: cover;\n    background-repeat: no-repeat;\n    background-image: url(\"/img/moonscape-bg.gif\");\n}\n}\n.sau-common-links h1 {\n  font-size: 1.625rem;\n}\n@media screen and (min-width: 1400px) {\n.sau-common-links h1 {\n    padding-bottom: 17px;\n}\n}", ""]);

// exports
